import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "47.458",
  viewBox: "0 0 47.458 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M47.458 50H27.966V33.79h-8.475v16.208H.001V21.82L23.728-.002l23.73 21.928zm-15.996-3.49h12.394v-23.1L23.729 4.77 3.602 23.41v23.093h12.394V30.189h15.466z"
  })]
});